import { Dispatch } from "redux";

// types
import { IEmployeeActionTypes, IEmployeeTypes } from "models/IEmployeeState";
import { IDesignationActionTypes } from "models/IDesginationState";
import { IWorkTypeActionTypes } from "models/IWorkTypeState";
import { IEntityActionTypes } from "models/IEntitiesState";
import { ISkillActionTypes } from "models/ISkillState";
import { ILocationActionTypes } from "models/ILocationState";
import { IJobUserDetailsActionTypes } from "models/IUserDetailsForJobState";

import { IAppActionTypes } from "models/IAppState";

import { IProjectActionTypes } from "models/IProjectState";
import { ISubProjectActionTypes } from "models/ISubProjectState";
import { ISingleEmployProfActionTypes } from "models/ISingleEmpProfDetails";
import { ISingleEmpPersDetailsActionTypes } from "models/ISingleEmpPersDetails";

import { raise_toast_message } from "actions/auth.action";

import { IHistory } from "models/ICommon";

// services
import employeeservice from "services/employeeService";

// configs
import { PATH_NAME } from "configs";

import employeeService from "services/employeeService";
import { IModuleActionTypes } from "models/IModules";

export const fetchusers =
  (entity_id: string, user_type_id?:string) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: IEmployeeActionTypes.FETCH_EMPLOYEE_LIST_REQUEST,
    });
    const response = await employeeService.fetchEmployees(entity_id, user_type_id);
    dispatch({
      type: IEmployeeActionTypes.FETCH_EMPLOYEE_LIST_SUCCESS,
      payload: {
        data: response.data,
      },
    });
  };

export const fetch_users =
  (reqBody: any) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: IEmployeeTypes.EMPLOYEE_LIST_REQUEST,
    });
    const response = await employeeService.fetch_employees(reqBody);
    dispatch({
      type: IEmployeeTypes.EMPLOYEE_LIST_SUCCESS,
      payload: response,
    });
  };

export const fetchdesignations =
  (entity_id: string, userid: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: IDesignationActionTypes.FETCH_DESIGNATION_LIST_REQUEST,
    });
    const response = await employeeService.fetchDesignations(entity_id, userid);
    dispatch({
      type: IDesignationActionTypes.FETCH_DESIGNATION_LIST_SUCCESS,
      payload: response?.data,
    });
  };

export const fetchWorkTypesList = () => async (dispatch: Dispatch<any>) => {
  dispatch({
    type: IWorkTypeActionTypes.FETCH_WORK_TYPES_REQUEST,
  });
  const response = await employeeService.fetchWorkTypes();
  dispatch({
    type: IWorkTypeActionTypes.FETCH_WORK_TYPES_SUCCESS,
    payload: {
      data: response.data,
    },
  });
};

export const fetchEntitiesList = () => async (dispatch: Dispatch<any>) => {
  dispatch({
    type: IEntityActionTypes.FETCH_ENTITIES_LIST_REQUEST,
  });
  const response = await employeeService.fetchEntities();
  dispatch({
    type: IEntityActionTypes.FETCH_ENTITIES_LIST_SUCCESS,
    payload: {
      data: response.data,
    },
  });
};

export const fetchSkills = () => async (dispatch: Dispatch<any>) => {
  dispatch({
    type: ISkillActionTypes.FETCH_SKILLS_LIST_REQUEST,
  });
  const response = await employeeService.fetchSkills();
  dispatch({
    type: ISkillActionTypes.FETCH_SKILLS_LIST_SUCCESS,
    payload: {
      data: response.data,
    },
  });
};

export const fetchLocations =
  (entityid: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: ILocationActionTypes.FETCH_LOCATION_LIST_REQUEST,
    });
    const response = await employeeService.fetchLocations(entityid);
    dispatch({
      type: ILocationActionTypes.FETCH_LOCATION_LIST_SUCCESS,
      payload: {
        data: response.data,
      },
    });
  };

export const fetchProjects =
  (entityid: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: IProjectActionTypes.FETCH_PROJECT_LIST_REQUEST,
    });
    const response = await employeeService.fetchProjects(entityid);
    dispatch({
      type: IProjectActionTypes.FETCH_PROJECT_LIST_SUCCESS,
      payload: {
        data: response.data,
      },
    });
  };

export const fetchprojects =
  (entityid: string, teamid: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: IProjectActionTypes.FETCH_PROJECT_LIST_REQUEST,
    });
    const response = await employeeService.fetch_projects(entityid, teamid);
    dispatch({
      type: IProjectActionTypes.FETCH_PROJECT_LIST_SUCCESS,
      payload: {
        data: response.data,
      },
    });
  };

export const fetchModules = () => async (dispatch: Dispatch<any>) => {
  dispatch({
    type: IModuleActionTypes.FETCH_MODULE_LIST_REQUEST,
  });
  const response = await employeeService.fetchmodules();
  dispatch({
    type: IModuleActionTypes.FETCH_MODULE_LIST_SUCCESS,
    payload: {
      data: response.data,
    },
  });
};

export const fetchSubProjectsFormultipelprojects =
  (projects: number | string) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: ISubProjectActionTypes.FETCH_SUB_PROJECT_LIST_REQUEST,
    });
    const response = await employeeService.fetchSubProjects(projects);
    dispatch({
      type: ISubProjectActionTypes.FETCH_SUB_PROJECT_LIST_SUCCESS,
      payload: {
        data: response.data,
      },
    });
  };

export const fetchSubProjects =
  (projectid: string | number) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: ISubProjectActionTypes.FETCH_SUB_PROJECT_LIST_REQUEST,
    });
    const response = await employeeService.fetchSubProjects(projectid);
    dispatch({
      type: ISubProjectActionTypes.FETCH_SUB_PROJECT_LIST_SUCCESS,
      payload: {
        data: response.data,
      },
    });
  };

export const fetchsubProjects =
  (projectid: string | number, subteamid: number) =>
  async (dispatch: Dispatch<any>) => {
    dispatch({
      type: ISubProjectActionTypes.FETCH_SUB_PROJECT_LIST_REQUEST,
    });
    const response = await employeeService.fetch_sub_projects(
      projectid,
      subteamid
    );
    dispatch({
      type: ISubProjectActionTypes.FETCH_SUB_PROJECT_LIST_SUCCESS,
      payload: {
        data: response.data,
      },
    });
  };

export const fetchEmployeeProfessionalDetails =
  (employeeID: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: ISingleEmployProfActionTypes.FETCH_EMP_PROF_DETAILS_LIST_REQUEST,
    });
    const response = await employeeService.fetchEmployeeProfessionalDetails(
      employeeID
    );
    dispatch({
      type: ISingleEmployProfActionTypes.FETCH_EMP_PROF_DETAILS_LIST_SUCCESS,
      payload: {
        data: response.data,
      },
    });
  };

export const fetchEmployPersonalDetails =
  (employeeID: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: ISingleEmpPersDetailsActionTypes.FETCH_EMP_PERSONAL_DETAILS_LIST_REQUEST,
    });
    const response = await employeeService.fetchEmployeePersonalDetails(
      employeeID
    );
    dispatch({
      type: ISingleEmpPersDetailsActionTypes.FETCH_EMP_PERSONAL_DETAILS_LIST_SUCCESS,
      payload: {
        data: response.data,
      },
    });
  };

export const updateEmployeeProfessionalDetails =
  (data: any) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: IJobUserDetailsActionTypes.UPDATE_USER_PROFESSIONAL_DETAILS_REQUEST,
    });
    const response = await employeeService.updateEmployeeProfessionalDetails(
      data
    );
    if (response?.status == 200) {
      dispatch({
        type: IJobUserDetailsActionTypes.UPDATE_USER_PROFESSIONAL_DETAILS_SUCCESS,
        payload: {
          data: response.data,
        },
      });

      data?.employee_id &&
        dispatch(fetchEmployeeProfessionalDetails(data?.employee_id));
      dispatch({
        type: IAppActionTypes.ENQUEUE_SNACKBAR,
        payload: {
          message: "successfully updated professional details",
          variant: "success",
          key: "updateprofessionalldetails",
        },
      });

      setTimeout(() => {
        dispatch({
          type: "HIDE_ALERT",
        });
      }, 2000);
    } else {
      dispatch({
        type: IJobUserDetailsActionTypes.UPDATE_USER_PROFESSIONAL_DETAILS_FAILURE,
      });
      dispatch({
        type: IAppActionTypes.ENQUEUE_SNACKBAR,
        payload: {
          message: "Failed to  update professional details",
          variant: "error",
          key: "updateprofessionalldetails",
        },
      });

      setTimeout(() => {
        dispatch({
          type: "HIDE_ALERT",
        });
      }, 2000);
    }
  };

export const add_employee_leads =
  (leadsList: any[], isSaveChanges: boolean = false) =>
  async (dispatch: Dispatch<any>) => {
    dispatch({
      type: IJobUserDetailsActionTypes.UPDATE_USER_PROFESSIONAL_DETAILS_REQUEST,
    });
    const response: any = await employeeService.add_employee_leads(leadsList);

    if (response?.status == 200) {

      if(isSaveChanges){
        dispatch(raise_toast_message("Changes saved", "success"))
      }else{
        dispatch(raise_toast_message("Lead added successfully", "success"))
      }

     ;
    } else {

      if(isSaveChanges){
        dispatch(raise_toast_message("Failed to save changes", "error"))
      }else{
        dispatch(raise_toast_message("Failed to add lead", "error"));
      }

     
    }
  };

export const remove_employee_lead =
  (employee_id: string, lead_id: string, is_nominal: boolean) =>
  async (dispatch: Dispatch<any>) => {
    dispatch({
      type: IJobUserDetailsActionTypes.UPDATE_USER_PROFESSIONAL_DETAILS_REQUEST,
    });
    const response: any = await employeeService.remove_employee_lead(
      employee_id,
      lead_id,
      is_nominal
    );

    if (response?.status == 200) {
      dispatch(raise_toast_message("Lead removed successfully", "success"));
    } else {
      dispatch(raise_toast_message("Failed to remove lead", "error"));
    }
  };

export const updateEmployeePersonalDetails =
  (data: any) => async (dispatch: Dispatch<any>) => {
    dispatch({
      type: IJobUserDetailsActionTypes.UPDATE_USER_PERSONAL_DETAILS_REQUEST,
    });

    try {
      const response = await employeeService.updateEmployeePersonalDetails(
        data
      );
      if (response?.status == 200) {
        dispatch({
          type: IJobUserDetailsActionTypes.UPDATE_USER_PERSONAL_DETAILS_SUCCESS,
          payload: {
            data: response.data,
          },
        });

        dispatch({
          type: IAppActionTypes.ENQUEUE_SNACKBAR,
          payload: {
            message: "successfully updated personal details",
            variant: "success",
            key: "updatepersonaldetails",
          },
        });

        data?.id && dispatch(fetchEmployPersonalDetails(data?.id));
        setTimeout(() => {
          dispatch({
            type: "HIDE_ALERT",
          });
        }, 2000);
      } else {
        dispatch({
          type: IJobUserDetailsActionTypes.UPDATE_USER_PERSONAL_DETAILS_FAILURE,
        });
        dispatch({
          type: IAppActionTypes.ENQUEUE_SNACKBAR,
          payload: {
            message: "Failed to  update personal details",
            variant: "error",
            key: "updatepersonaldetails",
          },
        });

        setTimeout(() => {
          dispatch({
            type: "HIDE_ALERT",
          });
        }, 2000);
      }
    } catch (e) {
      dispatch({
        type: IJobUserDetailsActionTypes.UPDATE_USER_PERSONAL_DETAILS_FAILURE,
      });
      dispatch({
        type: IAppActionTypes.ENQUEUE_SNACKBAR,
        payload: {
          message: "Failed to  update professional details",
          variant: "error",
        },
      });

      setTimeout(() => {
        dispatch({
          type: "HIDE_ALERT",
        });
      }, 2000);
    }
  };
